export default "__VITE_ASSET__BIG$r1Y0__"